// extracted by mini-css-extract-plugin
export default {"Chip":"styles_Chip__KNLE7"};